import { render, staticRenderFns } from "./orderSnapShotTable.vue?vue&type=template&id=d5edf744"
import script from "./orderSnapShotTable.vue?vue&type=script&lang=js"
export * from "./orderSnapShotTable.vue?vue&type=script&lang=js"
import style0 from "./orderSnapShotTable.vue?vue&type=style&index=0&id=d5edf744&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports